import axios from 'axios';
import { getNonGwApiRoot, getApiRoot } from '../../constants/ParamountReactConstants';
import * as utils from '../../utils/Utils';

export function fetchReplitIntegrations() {
  return {
    type: 'FETCH_REPLIT_INTEGRATIONS',
    payload: axios.get(`${getNonGwApiRoot()}/actions/integrations/replit-integrations`),
  };
}

export function fetchReplitAccessToken(
  appId: number,
  context?: {
    level?: string;
    account_id?: number;
    user_id?: number;
    brand_id?: number;
    brand_code?: string;
    receiver_id?: number;
    product_id?: number;
    part_number?: string;
  }
) {
  const urlParams = [{ name: 'app_id', values: appId }];

  // Add context parameters if provided
  if (context) {
    if (context.level) urlParams.push({ name: 'level', values: context.level as any });
    if (context.account_id) urlParams.push({ name: 'account_id', values: context.account_id });
    if (context.user_id) urlParams.push({ name: 'user_id', values: context.user_id });
    if (context.brand_id) urlParams.push({ name: 'brand_id', values: context.brand_id });
    if (context.brand_code)
      urlParams.push({ name: 'brand_code', values: context.brand_code as any });
    if (context.receiver_id) urlParams.push({ name: 'receiver_id', values: context.receiver_id });
    if (context.product_id) urlParams.push({ name: 'product_id', values: context.product_id });
    if (context.part_number)
      urlParams.push({ name: 'part_number', values: context.part_number as any });
  }

  const params = utils.createURL(urlParams);
  const tokenKey = `${appId}-${context?.level || 'default'}`;

  return {
    type: 'FETCH_REPLIT_ACCESS_TOKEN',
    payload: axios.get(`${getApiRoot()}/replit/access_token${params}`),
    meta: { tokenKey },
  };
}
